<template>
  <div class="navbar">
    <button
      type="button"
      class="mobile-menu-button"
      v-on:click="toggleMobileNav"
      aria-label="Open menu"
    >
      <font-awesome-icon icon="fa-solid fa-bars" />
    </button>
    <div class="d-flex justify-content-end align-items-center w-100">
      <div class="navbar-actions">
        <div class="dropdown">
          <div
            class="avatar dropdown-toggle"
            type="button"
            data-toggle="dropdown"
            id="dropdownMenuButton2"
          >
            {{ account ? $filters.capitalizedFirstLetter(account.fname) : "" }}
          </div>
          <div class="dropdown-menu dropdown-menu-end dropdown-menu-right" aria-labelledby="dropdownMenuButton2">
            <a class="dropdown-item" v-on:click="showProfileModal = true">Profile</a>
            <a v-on:click="logout()" class="dropdown-item final-item text-danger">Log out</a>
          </div>
        </div>
      </div>
    </div>
    <myProfileModal
      v-if="showProfileModal"
      @close-profile-modal="showProfileModal = false"
    />
  </div>
</template>
<script>
import { LOGOUT } from "@/store/action_types";
import myProfileModal from "@/components/user/My_Profile_Modal.vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faBars, faArrowLeft } from "@fortawesome/free-solid-svg-icons";

library.add(faBars, faArrowLeft);

export default {
  components: {
    myProfileModal,
  },
  data() {
    return {
      showProfileModal: false,
    };
  },
  computed: {
    route() {
      return this.$route.name;
    },
    account() {
      return this.$store.getters.account.data;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.go();
      });
    },
    toggleMobileNav() {
      window.dispatchEvent(new CustomEvent("ehs:toggle-mobile-nav"));
    },
  },
};
</script>
<style scoped>
.navbar {
  height: 3.5rem;
  background-color: var(--ehs-color-surface);
  border-bottom: 1px solid var(--ehs-color-border);
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 50;
}

.mobile-menu-button {
  display: none;
}

.avatar {
  width: 2.15rem;
  height: 2.15rem;
  background: linear-gradient(135deg, var(--ehs-color-primary) 0%, #bcdc44 100%);
  border: 1px solid transparent;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  font-size: 0.875rem;
  font-weight: 600;
  letter-spacing: -0.01em;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.08);
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.avatar:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(115, 196, 29, 0.25);
}

.navbar-actions {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.dropdown {
  margin-left: 5px;
  position: relative;
}

.dropdown .dropdown-toggle {
  font-size: 0.9rem;
}

.dropdown .dropdown-menu {
  right: 0 !important;
  left: auto !important;
  margin-top: 8px;
  min-width: 160px;
  transform: none !important;
}

@media (max-width: 991.98px) {
  .navbar {
    height: 3.25rem;
    padding: 0 20px;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
  }

  .navbar > .d-flex {
    flex: 1 1 auto;
    min-width: 0;
    height: 100%;
  }

  .navbar-actions {
    align-items: center;
    height: 100%;
  }

  .dropdown {
    margin-left: 0;
    display: flex;
    align-items: center;
  }

  .avatar {
    width: 2rem;
    height: 2rem;
    font-size: 0.9em;
  }

  .mobile-menu-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 38px;
    border: 1px solid var(--ehs-color-border);
    border-radius: var(--ehs-radius-sm);
    background: var(--ehs-color-surface);
    color: var(--ehs-color-ink);
    cursor: pointer;
    box-shadow: none !important;
    flex-shrink: 0;
    margin-right: 10px;
  }
}
</style>
